type BrazeAllowedInput = {
  consentAllowed: boolean;
  contactPermission: boolean | null | undefined;
  pushPermissionGranted: boolean | null | undefined;
};

export const isBrazeAllowed = ({
  consentAllowed,
  contactPermission,
  pushPermissionGranted,
}: BrazeAllowedInput): boolean =>
  consentAllowed || contactPermission === true || pushPermissionGranted === true;
